import React, { Component } from "react";
import styles from './FJResourceOverLayMore.module.less';
import classNames from 'classnames';
import FJToolContent from 'fj-components/FJToolContent'
import FJPageHeaderBack from 'fj-components/FJPageHeaderBack'
import FJCustomScroll from 'fj-components/FJCustomScroll'
import FJFixedLayout from 'fj-components/FJFixedLayout'
import FJResourcesOverLayCommon from "./FJResourcesOverLayCommon";



class FJResourceOverLayMore extends Component {

	_getCollectionList = () => {
		let {
			resourceViewInfo,
			list,
			onAddClick,
			onHandleClick,
			onMediaDrag,
			classes,
			config,
			allTooltip,
			toggleTooltip,
			oneTooltip,
			chooseMediaIdList
		} = this.props;

		let {
			width,
			height,
			space,
			marginBottom
		} = resourceViewInfo;

		let {
			addIcon,
			deleteIcon,
			activeColor,
			addIconToolTip,
		} = config;

		return <FJFixedLayout
			basicWidth={width}
			space={space}
			active={list.length}
			render={(itemWidth, space, column) => {
				let itemHeight = height;
				return list.map((item, index) => (
					<FJResourcesOverLayCommon
						key={item.name}
						id={item.name}
						width={itemWidth}
						height={itemHeight}
						marginRight={(index + 1) % column === 0 ? 0 : space}
						marginBottom={marginBottom}
						thumbnail={item.thumbnail}
						url={item.url}
						name={item.title}
						hasName={false}
						type={item.type}
						hasAddBtn
						onAddClick={onAddClick}
						selectMedia={onHandleClick}
						classes={classes.itemClasses}
						activeColor={activeColor}
						addIcon={addIcon}
						deleteIcon={deleteIcon}
						onMediaDrag={onMediaDrag}
						addIconToolTip={addIconToolTip}
						allTooltip={allTooltip}
						toggleTooltip={toggleTooltip}
						oneTooltip={oneTooltip}
						isChoose={chooseMediaIdList.indexOf(item.name) !== -1}
					/>
				))
			}}
		/>
	}

	render() {

		let {
			isShow,
			backElement,
			backTitle,
			title,
			classes
		} = this.props

		let cn = classNames(styles.more_box, isShow ? 'show' : 'hide')

		return (
			<div className={cn}>
				<FJToolContent active={isShow}>
					<FJPageHeaderBack onClick={backElement} backText={backTitle} title={title} classes={classes.pageHeaderBackClasses}>
						<div className={styles.clint_box}>
							<FJCustomScroll classes={classes.scrollClasses}>
								<div className={ classNames(styles.inner, classes.textMoreInnerBox) }>
									{this._getCollectionList()}
								</div>
							</FJCustomScroll>
						</div>
					</FJPageHeaderBack>
				</FJToolContent>
			</div>
		)
	}

}


export default FJResourceOverLayMore;